var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6E5FE",
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.811 16.33A15.552 15.552 0 0 1 20 11.6c4.388 0 8.356 1.813 11.189 4.73a.9.9 0 0 1-.01 1.263l-.423.425a.9.9 0 0 1-1.283-.01A13.161 13.161 0 0 0 20 14a13.161 13.161 0 0 0-9.473 4.008.9.9 0 0 1-1.283.01l-.423-.425a.9.9 0 0 1-.01-1.264m3.39 3.4A10.776 10.776 0 0 1 20 16.4a10.776 10.776 0 0 1 7.799 3.329.9.9 0 0 1-.013 1.259l-.425.424a.9.9 0 0 1-1.287-.014A8.376 8.376 0 0 0 20 18.8a8.371 8.371 0 0 0-6.073 2.598.9.9 0 0 1-1.288.014l-.425-.424a.9.9 0 0 1-.012-1.26m3.384 3.408a6 6 0 0 1 8.83 0 .9.9 0 0 1-.026 1.248l-.425.424a.9.9 0 0 1-1.302-.03 3.6 3.6 0 0 0-5.327 0 .9.9 0 0 1-1.3.03l-.426-.424a.9.9 0 0 1-.025-1.247m3.354 3.302a1.5 1.5 0 0 1 2.122 0 .9.9 0 0 1 0 1.272l-.425.425a.9.9 0 0 1-1.272 0l-.425-.424a.9.9 0 0 1 0-1.272",
    fill: "#821BB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep2);
export default __webpack_public_path__ + "static/media/icon-step-2.ee5e6b6e0bc7f3ae49c797393211cd00.svg";
export { ForwardRef as ReactComponent };